const columnSizes: { minWidth: string; containerWidth: number }[] = [
  {
    minWidth: 'sm',
    containerWidth: 510
  },
  {
    minWidth: 'md',
    containerWidth: 682
  },
  {
    minWidth: 'lg',
    containerWidth: 767
  },
  {
    minWidth: 'xl',
    containerWidth: 955
  },
  {
    minWidth: 'xxl',
    containerWidth: 1210
  }
];

export default columnSizes;
